import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import PopupModal from '../../Manage/PopupModal';

const JobApplicationDesc = (props) => {
    const { data } = props;

    const [modal, setModal] = useState(false);
    const handleModal = () => setModal(!modal);

    const [openName, setOpenName] =  useState('')
    // const [data12, setData] =  useState([])

    const clickHandler = (name) => {
      setModal(true)    
      console.log('NAME', name)
          setOpenName(name)
        //   setData(data)
    
    }


    return (
        <div>
            <Row>
                <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Job Title:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.jobTitle}</Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Application ID:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.applicationId}</Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Application Date:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.date}</Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}> Current Status:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.status}</Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Last Update:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>March 20, 2024</Col>
                    </Row>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                    <br/>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='3' lg='3' md='3' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Application Progress:</Col>
                        <Col xl='9' lg='9' md='9' sm='12' xs='12'>{'[Pending -> Under Review -> Interview Scheduled -> Offer -> Hired]'}</Col>
                    </Row>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='3' lg='3' md='3' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Documents Submitted:</Col>
                        <Col xl='9' lg='9' md='9' sm='12' xs='12'>Resume, Portfolio, Cover Letter</Col>
                    </Row>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='3' lg='3' md='3' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Next Steps:</Col>
                        <Col xl='9' lg='9' md='9' sm='12' xs='12'>Expect feedback by March 22, 2024</Col>
                    </Row>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='3' lg='3' md='3' sm='12' xs='12' style={{ fontWeight: 'bold' }}>HR Contact:</Col>
                        <Col xl='9' lg='9' md='9' sm='12' xs='12'>hr@yourcompany.com</Col>
                    </Row>
                </Col>
                {
                    data?.status == 'Under Review' ? 
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='3' lg='3' md='3' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Actions:</Col>
                        <Col xl='9' lg='9' md='9' sm='12' xs='12'>
                            <div style={{display:'flex', flexDirection:'row', width:'80%'}}>
                                <Row className='w-100'>
                                    <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                                        <div style={{cursor:'pointer'}}>Download Application</div>
                                    </Col>
                                    <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                                        <div style={{cursor:'pointer'}} onClick={()=> clickHandler('Withdraw Application')}>Withdraw Application</div>
                                    </Col>
                                </Row>
                                
                                
                            </div>
                        </Col>
                    </Row>
                </Col>
                    : ''
                }
               
            </Row>

            <PopupModal
                company_id={''}
                open={modal}
                setModal={setModal}
                handleModal={handleModal}
                name={openName}
                // tableData={openName == 'Withdraw Application' ? data12 : ""}
                tableData={""}
                setTableData={''}
            />
        </div>
    );
};

export default JobApplicationDesc;
